import React from 'react';
import { Layout, Menu, Typography } from 'antd';
import { UserOutlined, AppstoreOutlined, DashboardOutlined, LogoutOutlined } from '@ant-design/icons';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

const { Header, Sider, Content } = Layout;
const { Title } = Typography;

const items = [
  { key: '/superadmin', icon: <DashboardOutlined />, label: 'Dashboard' },
  { key: '/superadmin/users', icon: <UserOutlined />, label: 'Users' },
  { key: '/superadmin/companies', icon: <AppstoreOutlined />, label: 'Companies' },
  { key: '/login', icon: <LogoutOutlined />, label: 'Exit' },
];

const SuperadminLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const selectedKey = items.find(i => location.pathname.startsWith(i.key))?.key || '/superadmin';

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider width={220} theme="light">
        <div className="flex items-center h-16 px-4 border-b">
          <div className="h-9 w-9 rounded-lg bg-sky-500 text-white flex items-center justify-center font-bold mr-2">SA</div>
          <Title level={5} style={{ margin: 0 }}>Superadmin</Title>
        </div>
        <Menu
          mode="inline"
          selectedKeys={[selectedKey]}
          onClick={({ key }) => navigate(key)}
          items={items}
          style={{ borderRight: 0 }}
        />
      </Sider>
      <Layout>
        <Header style={{ background: 'transparent', height: 64 }} />
        <Content style={{ padding: 24 }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default SuperadminLayout;
